export interface BrandConfigEntry {
  lightLogo:  string;
  logo:   string;
  nube:       string;
}

// Utility function to check if a file exists
const checkFileExists = async (url: string): Promise<boolean> => {
  try {
    console.log(`Checking file existence: ${url}`);
    const response = await fetch(url, { method: 'GET' });
    
    // Check if response is ok
    if (!response.ok) {
      console.log(`File not found (status ${response.status}): ${url}`);
      return false;
    }
    
    // Get content type and content length
    const contentType = response.headers.get('content-type');
    const contentLength = response.headers.get('content-length');
    
    console.log(`Response for ${url}:`, {
      status: response.status,
      contentType,
      contentLength
    });
    
    // If it's an SVG, check content type
    if (url.toLowerCase().endsWith('.svg')) {
      // SVG should have SVG content type or be text/plain
      if (contentType && (contentType.includes('svg') || contentType.includes('text/plain'))) {
        // For SVG, we need to check the actual content
        const text = await response.text();
        // Check if it looks like SVG content (contains SVG tags)
        if (text.includes('<svg') || text.includes('<?xml')) {
          console.log(`SVG file found and valid: ${url}`);
          return true;
        } else {
          console.log(`SVG file found but content is not valid SVG: ${url}`);
          return false;
        }
      }
      console.log(`SVG file not found (wrong content type): ${url}`);
      return false;
    }
    
    // For PNG files, check if content length is reasonable (not 0 or very small)
    if (url.toLowerCase().endsWith('.png')) {
      if (contentType && contentType.includes('image/png')) {
        const length = parseInt(contentLength || '0');
        if (length > 100) {
          console.log(`PNG file found and valid: ${url}`);
          return true;
        } else {
          console.log(`PNG file found but too small: ${url} (${length} bytes)`);
          return false;
        }
      }
      console.log(`PNG file not found (wrong content type): ${url}`);
      return false;
    }
    
    // For other file types, just check if response is ok
    console.log(`Other file type found: ${url}`);
    return response.ok;
  } catch (error) {
    console.log('Error checking file existence:', error);
    return false;
  }
};

// Function to get the best available logo (SVG first, then PNG fallback)
export const getLogoWithFallback = async (svgPath: string): Promise<string> => {
  // First try the SVG
  if (await checkFileExists(svgPath)) {
    return svgPath;
  }
  
  // If SVG doesn't exist, try PNG with same name
  const pngPath = svgPath.replace(/\.svg$/i, '.png');
  if (await checkFileExists(pngPath)) {
    return pngPath;
  }
  
  // If neither exists, return the original path (will show broken image)
  return svgPath;
};

// Function to get all logos with fallbacks for a brand
export const getBrandLogosWithFallback = async (brand: string): Promise<BrandConfigEntry> => {
  const config = brandConfig[brand] || brandConfig.default;
  
  const [logo, lightLogo, nube] = await Promise.all([
    getLogoWithFallback(config.logo),
    getLogoWithFallback(config.lightLogo),
    getLogoWithFallback(config.nube)
  ]);
  console.log(logo, lightLogo, nube);
  return {
    logo,
    lightLogo,
    nube
  };
};

export const brandConfig: Record<string, BrandConfigEntry> = {
  ctx: {
    logo:"/ctx/Logo.svg",
    nube: "/ctx/Nube_new.png",
    lightLogo: "/ctx/LogoWhite.svg",
  },
  mithub: {
    logo: "/mithhub/Logo.svg",
    lightLogo: "/mithhub/LogoWhite.svg",
    nube: "/mithhub/mithub.png",
  },
  default: {
    logo: "/default/Logo.svg",
    nube: "/default/Nube_new.png",
    lightLogo: "/default/LogoWhite.svg",
  },
};

